<mojo-viewbar></mojo-viewbar>
<mojo-page-title [title]="pageTitle$ | async"></mojo-page-title>

<section class="panel data-table full-page-widget full-page-scrollable" [class.mojo-admin-page]="useMojoAdminStyling">
  <div class="panel-body">
    <mojo-widget-table [widgetConfigurations]="widgetConfigurations$ | async" [loading]="loading$ | async"
                       (onRowClicked)="configSelected($event)"></mojo-widget-table>
  </div>
</section>

<p-dialog [style]="{height: '450px', minWidth: '800px'}" [closeOnEscape]="false" [closable]="false"
          [header]="dialogTitle" [(visible)]="displayDialog" [responsive]="true" showEffect="fade" [modal]="true"
          appendTo="body" [styleClass]="'widget-admin-pop-up admin-form'">
  <mojo-dynamic-form [formDefinition]="formDefinition | async" [displayDeleteButton]="displayDeleteButton()"
                     [displayResetAllUsersButton]="displayResetAllUsersButton()"
                     (onCancel)="closeDialog()"
                     (onSave)="dialogSaved($event)"
                     (onCreateCopy)="createCopy($event)"
                     (onDelete)="performDelete($event)"
                     (onResetAllUsersToDefaultColumns)="resetAllUsersToDefaultColumns()"
  ></mojo-dynamic-form>
</p-dialog>
